var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M18.3536 19.3536C18.5488 19.1583 18.5488 18.8417 18.3536 18.6464C18.1583 18.4512 17.8417 18.4512 17.6464 18.6464L18.3536 19.3536ZM14 23L13.6464 22.6464L13.2929 23L13.6464 23.3536L14 23ZM17.6464 27.3536C17.8417 27.5488 18.1583 27.5488 18.3536 27.3536C18.5488 27.1583 18.5488 26.8417 18.3536 26.6464L17.6464 27.3536ZM17.6464 18.6464L13.6464 22.6464L14.3536 23.3536L18.3536 19.3536L17.6464 18.6464ZM13.6464 23.3536L17.6464 27.3536L18.3536 26.6464L14.3536 22.6464L13.6464 23.3536Z",
    fill: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-path": "stroke",
    d: "M22.0622 12.5C22.7138 13.6286 23.0374 14.9167 22.9966 16.2193C22.9557 17.5219 22.5521 18.7872 21.8311 19.8728C21.11 20.9584 20.1003 21.8212 18.9155 22.364C17.7307 22.9067 16.4179 23.108 15.1249 22.9451",
    stroke: "#1D1D46",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M13.6464 12.6464C13.4512 12.8417 13.4512 13.1583 13.6464 13.3536C13.8417 13.5488 14.1583 13.5488 14.3536 13.3536L13.6464 12.6464ZM18 9L18.3536 9.35355L18.7071 9L18.3536 8.64645L18 9ZM14.3536 4.64645C14.1583 4.45118 13.8417 4.45118 13.6464 4.64645C13.4512 4.84171 13.4512 5.15829 13.6464 5.35355L14.3536 4.64645ZM14.3536 13.3536L18.3536 9.35355L17.6464 8.64645L13.6464 12.6464L14.3536 13.3536ZM18.3536 8.64645L14.3536 4.64645L13.6464 5.35355L17.6464 9.35355L18.3536 8.64645Z",
    fill: "#1D1D46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-path": "stroke",
    d: "M9.93782 19.5C9.27676 18.355 8.95347 17.0462 9.0054 15.7251C9.05733 14.404 9.48234 13.1246 10.2312 12.035C10.9801 10.9454 12.0223 10.0902 13.2371 9.56834C14.4519 9.04649 15.7896 8.87934 17.0955 9.08625",
    stroke: "#1D1D46",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.836fe450d391825b4433227cf36822c8.svg";
export { ForwardRef as ReactComponent };